import { createContext, type ReactNode, useContext } from 'react';
import { PRINT_PREVIEW_KEY } from '../consts/print';

const PrintContext = createContext<boolean>(false);

interface PrintProviderProps {
  children: ReactNode;
  searchParams?: Record<string, string>;
}

export function PrintProvider({ children, searchParams }: PrintProviderProps) {
  const isPrinting = searchParams?.[PRINT_PREVIEW_KEY] === 'true';

  return <PrintContext.Provider value={isPrinting}>{children}</PrintContext.Provider>;
}

export function usePrint(): boolean {
  return useContext(PrintContext);
}
